import Swiper from "swiper";
import { Navigation, Pagination } from 'swiper/modules';

class FeatureGallery extends HTMLElement {
  constructor(){
    super();

    this.image  = this.querySelector('.feature-gallery__image');
    this.slider = this.querySelector('.swiper');
    this.sliderPagination = this.querySelector('.swiper-pagination');
    this.swiper = undefined;
  }

  connectedCallback() {
    this.onInitSlider();
  }

  static get observedAttributes() {
    return ['active'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'active') {
      this.handleActiveChange(newValue);
    }
  }

  handleActiveChange(value){

  }

  onToggle(){
    let toggle = JSON.parse(this.image.getAttribute('data-show'));
    let toggleOne = JSON.parse(this.sliderPagination.getAttribute('data-show'));

    this.image.setAttribute('data-show', !toggle);
    this.sliderPagination.setAttribute('data-show', !toggleOne);
  }

  onInitSlider(){
    this.swiper = new Swiper(this.slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: '.feature-gallery__next',
        prevEl: '.feature-gallery__prev'
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      on: {
        slideChangeTransitionEnd: (e) => {
          if (this.swiper) {
            const imageNumber = e.realIndex + 1;
            let direction;

            if (e.realIndex === e.previousRealIndex + 1 || (e.realIndex === 0 && e.previousRealIndex === e.slides.length - 1)) {
              direction = 'next';
            } else {
              direction = 'prev';
            }

            // Send event Google Analytics 4
            gtag('event', 'pdp_carousel_navigation', {
              carousel_id: 'pdp_featured_gallery_slider',
              direction: direction,
              image_number: imageNumber,
              page_location: window.location.href
            });
          }
        }
      }
    });
  }
}

window.customElements.define('feature-gallery', FeatureGallery);
